/**
 * Build searchable text records for Cloudflare Vectorize (whole ERP catalog).
 */

import i18n from '../../i18n';

const vb = (key, opts) => i18n.t(`modules.shared.aiAgent.vectorizeBuilder.${key}`, opts);

function joinParts(parts) {
  return parts.filter(Boolean).join(' | ');
}

function clientText(c) {
  const name = c.name || c.company_name || c.companyName || vb('unnamed');
  return joinParts([
    vb('client_label', { name }),
    c.type ? vb('type_label', { value: c.type }) : '',
    c.phone ? vb('phone_label', { value: c.phone }) : '',
    c.email ? vb('email_label', { value: c.email }) : '',
    c.address ? vb('address_label', { value: c.address }) : '',
    c.city ? vb('city_label', { value: c.city }) : '',
    c.notes ? vb('notes_label', { value: c.notes }) : '',
    c.id ? vb('id_label', { value: c.id }) : '',
  ]);
}

function productText(p) {
  const name = p.name || vb('unnamed');
  return joinParts([
    vb('product_label', { name }),
    p.reference ? vb('reference_label', { value: p.reference }) : '',
    p.barcode ? vb('barcode_label', { value: p.barcode }) : '',
    p.category ? vb('category_label', { value: p.category }) : '',
    p.price != null ? vb('price_label', { value: p.price }) : '',
    p.stock != null ? vb('stock_label', { value: p.stock }) : '',
    p.description ? vb('description_label', { value: p.description }) : '',
    p.notes ? vb('notes_label', { value: p.notes }) : '',
    p.id ? vb('id_label', { value: p.id }) : '',
  ]);
}

function supplierText(s) {
  const name = s.name || s.company_name || s.companyName || vb('unnamed');
  return joinParts([
    vb('supplier_label', { name }),
    s.phone ? vb('phone_label', { value: s.phone }) : '',
    s.email ? vb('email_label', { value: s.email }) : '',
    s.address ? vb('address_label', { value: s.address }) : '',
    s.city ? vb('city_label', { value: s.city }) : '',
    s.notes ? vb('notes_label', { value: s.notes }) : '',
    s.id ? vb('id_label', { value: s.id }) : '',
  ]);
}

function serviceText(s) {
  const name = s.name || vb('unnamed');
  return joinParts([
    vb('service_label', { name }),
    s.reference ? vb('reference_label', { value: s.reference }) : '',
    s.category ? vb('category_label', { value: s.category }) : '',
    s.price != null ? vb('price_label', { value: s.price }) : '',
    s.description ? vb('description_label', { value: s.description }) : '',
    s.notes ? vb('notes_label', { value: s.notes }) : '',
    s.id ? vb('id_label', { value: s.id }) : '',
  ]);
}

function categoryText(c) {
  const name = c.name || vb('unnamed');
  return joinParts([
    vb('category_entity_label', { name }),
    c.description ? vb('description_label', { value: c.description }) : '',
    c.type ? vb('type_label', { value: c.type }) : '',
    c.id ? vb('id_label', { value: c.id }) : '',
  ]);
}

export function buildVectorizeRecordsFromCatalog(catalog) {
  const records = [];

  (catalog.clients || []).forEach((c) => {
    if (!c?.id) return;
    records.push({
      id: String(c.id),
      type: 'client',
      name: c.name || c.company_name || c.companyName,
      text: clientText(c),
    });
  });

  (catalog.products || []).forEach((p) => {
    if (!p?.id) return;
    records.push({
      id: String(p.id),
      type: 'product',
      name: p.name,
      text: productText(p),
    });
  });

  (catalog.suppliers || []).forEach((s) => {
    if (!s?.id) return;
    records.push({
      id: String(s.id),
      type: 'supplier',
      name: s.name || s.company_name || s.companyName,
      text: supplierText(s),
    });
  });

  (catalog.services || []).forEach((s) => {
    if (!s?.id) return;
    records.push({
      id: String(s.id),
      type: 'service',
      name: s.name,
      text: serviceText(s),
    });
  });

  (catalog.categories || []).forEach((c) => {
    if (!c?.id) return;
    records.push({
      id: String(c.id),
      type: 'category',
      name: c.name,
      text: categoryText(c),
    });
  });

  return records;
}

export function catalogFingerprint(catalog) {
  const counts = [
    catalog.clients?.length || 0,
    catalog.products?.length || 0,
    catalog.suppliers?.length || 0,
    catalog.services?.length || 0,
    catalog.categories?.length || 0,
  ];
  return counts.join(':');
}
